export enum ExpenseType {
  Unknown = 0,
  Fuel = 1,
  Def = 2,
  Repair = 3,
  Travel = 4,
  Tolls = 5,
  Other = 6,
  Insurance = 7,
  Lease = 8,
  VEDR = 9,
  ELD = 10
}

export const ExpenseTypeMapping: Record<ExpenseType, string> = {
  [ExpenseType.Unknown]: 'Unknown',
  [ExpenseType.Fuel]: 'Fuel',
  [ExpenseType.Def]: 'DEF',
  [ExpenseType.Repair]: 'Repair & Maintenance',
  [ExpenseType.Travel]: 'Travel',
  [ExpenseType.Tolls]: 'Tolls',
  [ExpenseType.Other]: 'Other',
  [ExpenseType.Insurance]: 'Insurance',
  [ExpenseType.Lease]: 'Lease / Payment',
  [ExpenseType.VEDR]: 'VEDR',
  [ExpenseType.ELD]: 'ELD'
};
